import { Stack } from "@mui/material";
import React from "react";
import { ListingCoverImage } from "./ListingCoverImage";
import { ListingShare, ShareProvider } from "./trainingShare";
import { ListingSave } from "./ListingSave";

export const ListingHeroSection = () => {
  return (
    <Stack className="w-full space-y-[23px]">
      <ListingCoverImage />
      <div className="flex space-x-4 sm:hidden">
        <ShareProvider>
          <ListingShare />
        </ShareProvider>

        <ListingSave />
      </div>
    </Stack>
  );
};
